import { useEffect, useState } from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import BlogCard from "../../Reusable/BlogCard/BlogCard.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Adsense from "../../Reusable/Adsense/Adsense.js";
import Image from "components/Elements/Image/Image.tsx";

import "./BlogHomePage.scss";

const BlogHomePage = () => {
  const [articles, setArticles] = useState();
  const { getPageText, getLanguageCulture, getHtmlByKey } = useContent();
  const { Desktop } = useMediaQueries();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    apiRequest(
      "BlogArticles",
      `ReactGetBlogArticles?blogculture=${getLanguageCulture().slice(0, 2)}`
    ).then((response) => {
      setArticles(response.data);
      setLoading(false);
    });
  }, [getLanguageCulture]);

  //add empty alt and title to CoverImage
  return (
    <>
      <div className="image-wrapper">
        <Image
          name="blog-cover-img"
          ext="jpg"
          alt="Cover Picture"
          title="Cover Picture"
        />
        <div className="jumbomail-logo">
          <Icon
            name={"jumbomail-logo-small"}
            xxl
            white
            title="JUMBOmail"
            alt="JUMBOmail"
          />
        </div>
        <h1 className="jumbomail-blog-text">{getPageText().Display_title}</h1>
      </div>
      <Desktop>
        <Adsense bannerPosition="blog-left-side" />
      </Desktop>
      <Desktop>
        <Adsense bannerPosition="blog-right-side" />
      </Desktop>
      {!loading ? (
        <div className="blog-articles">
          {articles && articles.length > 0 ? (
            <div className="blog-articles-row">
              {articles.map((article) => (
                <BlogCard key={article.BlogArticleId} article={article} />
              ))}
            </div>
          ) : (
            <div className="blog-no-articles-text">
              {getHtmlByKey("no-articles-text")}
            </div>
          )}
        </div>
      ) : (
        <div className="loading-blog-container">
          <Image
            className="loader-animation-gif"
            name="preloader"
            ext="gif"
            alt=""
            title=""
          />
        </div>
      )}
    </>
  );
};

export default BlogHomePage;
